import React from 'react';
import styles from './Dashboard.module.css';

export default function AccountSettings() {
  return (
    <div className={styles.page}>
      <div className={styles.pageHeader}>
        <h1 className={styles.pageTitle}>Account Settings</h1>
        <p className={styles.pageSubtitle}>Manage your personal information and billing.</p>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '24px' }}>
        
        {/* Profile Details */}
        <div className={styles.card}>
          <h2 className={styles.cardTitle}>Profile Information</h2>
          <form onSubmit={e => e.preventDefault()}>
            <div className={styles.formGroup}>
              <label className={styles.label}>Full Name</label>
              <input type="text" className={styles.input} defaultValue="Client Portal User" />
            </div>
            <div className={styles.formGroup}>
              <label className={styles.label}>Email Address</label>
              <input type="email" className={styles.input} defaultValue="client@example.com" readOnly />
            </div>
            <button type="submit" className="btn btn-primary">Save Changes</button>
          </form>
        </div>

        {/* Plan Info */}
        <div className={styles.card} style={{ height: 'fit-content' }}>
          <h2 className={styles.cardTitle}>Plan Details</h2>
          <div style={{ background: 'var(--bg3)', border: '1px solid var(--border)', borderRadius: 'var(--radius-sm)', padding: '16px', marginBottom: '24px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px' }}>
              <span style={{ fontWeight: '500' }}>Current Tier</span>
              <span className={`${styles.badge} ${styles.badgeGreen}`}>Standard</span>
            </div>
            <div style={{ color: 'var(--text2)', fontSize: '14px' }}>$129/month</div>
          </div>
          <button className="btn btn-outline" style={{ width: '100%', justifyContent: 'center' }}>
            Upgrade Plan
          </button>
        </div>

        {/* Password Reset */}
        <div className={styles.card}>
          <h2 className={styles.cardTitle}>Change Password</h2>
          <form onSubmit={e => e.preventDefault()}>
            <div className={styles.formGroup}>
              <label className={styles.label}>Current Password</label>
              <input type="password" className={styles.input} placeholder="••••••••" />
            </div>
            <div className={styles.formGroup}>
              <label className={styles.label}>New Password</label>
              <input type="password" className={styles.input} placeholder="••••••••" />
            </div>
            <div className={styles.formGroup}>
              <label className={styles.label}>Confirm New Password</label>
              <input type="password" className={styles.input} placeholder="••••••••" />
            </div>
            <button type="submit" className="btn btn-outline">Update Password</button>
          </form>
        </div>

      </div>
    </div>
  );
}
